import { defaultSelectedOffer } from '@modules/offer/domain/offer.const'

export const initialState = {
  specsError: null,
  offerError: null,
  offerResult: null,
  radiationError: null,
  specsFormValidation: {},
  specs: {},
  specsResult: null,
  preOffers: {},
  finalOffers: {},
  simulatedOffer: {},
  activeOfferContext: 'preOffers',
  selectedOffer: defaultSelectedOffer,
  installationTax: '',
  taxType: '',
  dueDate: '',
  financingConditions: [],
  selectedFinancingCondition: 'cash',
  loadingIndirectSolarOfferPdf: false,
  errorDownloadIndirectSolarOfferPdf: false,
  showIndirectDownloadPdfAlert: false,
  isVerified: '',
  // Consumo anual que devuelve solarproduct con la oferta (null hasta tener oferta).
  offerConsumption: null,
  isOfferable: null,
  isOfferableError: false,
  isSimulatedOfferLoading: false,
  clientType: '',
  hasDoneEnergyReform: '',
  assetsCatalog: [],
  loadingAssetsCatalog: false,
  errorAssetsCatalog: false,
  contract: null,
  contractError: null,
  isSimulationOfferHidden: false,
  isApplyingDiscount: false,
  applyDiscountError: null,
}

export default () => ({ ...initialState })
